import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import CommandResult from "../../Common/Models/CommandResult";
import InstrumentSubTypeLookup from "../Instruments/Models/Lookups/InstrumentSubTypeLookup";
import InstrumentTypeDropDownLookup from "../InstrumentTypes/Models/Lookups/InstrumentTypeDropDownLookup"
import CreateInstrumentSubtypeCommand from "../InstrumentTypes/Models/Commands/CreateInstrumentSubtypeCommand";
import CreateInstrumentTypeCommand from "../InstrumentTypes/Models/Commands/CreateInstrumentTypeCommand";
import UpdateInstrumentSubtypeCommand from "../InstrumentTypes/Models/Commands/UpdateInstrumentSubtypeCommand";
import UpdateInstrumentTypeCommand from "../InstrumentTypes/Models/Commands/UpdateInstrumentTypeCommand";
import InstrumentTypeLookup from "../InstrumentTypes/Models/Lookups/InstrumentTypeLookup";
import InstrumentTypeSearchCriteria from "../InstrumentTypes/Models/Queries/InstrumentTypeSearchCriteria";

export interface IInstrumentTypeApiClient {
    getInstrumentSubTypesByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<InstrumentSubTypeLookup>>>;
    getInstrumentTypeListFromCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<InstrumentTypeDropDownLookup>>>;
    getInstrumentSubTypeListFromCriteriaAndTypeName(criteria: string, instrumentTypeName?: string): AxiosPromise<Array<Model.PlainObject<InstrumentSubTypeLookup>>>;
    getPagedInstrumentTypes(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<InstrumentTypeSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<InstrumentTypeLookup>>>;
    addNewInstrumentType(command: Model.PlainObject<CreateInstrumentTypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    addNewInstrumentSubtype(command: Model.PlainObject<CreateInstrumentSubtypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateInstrumentType(command: Model.PlainObject<UpdateInstrumentTypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateInstrumentSubtype(command: Model.PlainObject<UpdateInstrumentSubtypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
}

@injectable()
export default class InstrumentTypeApiClient extends Data.ApiClientBase implements IInstrumentTypeApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/InstrumentSubtype`)
    }

    public getInstrumentSubTypesByCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<InstrumentSubTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetInstrumentSubTypes`, { params: { criteria: criteria } });
    }

    public getInstrumentSubTypeListFromCriteriaAndTypeName(criteria: string, instrumentTypeName?: string): AxiosPromise<Array<Model.PlainObject<InstrumentSubTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetInstrumentSubtypeListFromCriteriaAndTypeName`, { params: { criteria: criteria, instrumentTypeName: instrumentTypeName } });
    }

    public getInstrumentTypeListFromCriteria(criteria: string): AxiosPromise<Array<Model.PlainObject<InstrumentTypeDropDownLookup>>> {
        return this.axios.get(`${this.apiPath}/GetInstrumentTypeListFromCriteria`, { params: { criteria: criteria } });
    }

    public getPagedInstrumentTypes(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<InstrumentTypeSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<InstrumentTypeLookup>>> {
        return this.axios.get(`${this.apiPath}/GetInstrumentTypesPagedList?${Utils.getQueryString(payload)}`);
    }

    public addNewInstrumentType(command: Model.PlainObject<CreateInstrumentTypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewInstrumentType`, command);
    }

    public addNewInstrumentSubtype(command: Model.PlainObject<CreateInstrumentSubtypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewInstrumentSubtype`, command);
    }

    public updateInstrumentType(command: Model.PlainObject<UpdateInstrumentTypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateInstrumentType`, command);
    }

    public updateInstrumentSubtype(command: Model.PlainObject<UpdateInstrumentSubtypeCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.patch(`${this.apiPath}/UpdateInstrumentSubtype`, command);
    }
}